module.exports = __webpack_public_path__ + "img/kaios.2932d203.svg";